module.exports = __webpack_public_path__ + "img/profitability6.4678ebe4.png";